module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg1.jpg",
      "width": "81.30%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-top": "8%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_vm._v("T")]), _vm._v("he girls were playing with the Frozen Charlotte dolls again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The schoolmistress had given them some scraps of fabric and ribbon from the sewing room to take out to the garden. They were to practice their embroidery skills by making little dresses and bonnets for the naked porcelain dolls. “They’ll catch their death of cold otherwise,” the teacher had said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But there was one girl who wasn’t playing with the others. The schoolmistress sighed when she saw her, sitting alone, fiddling with her blindfold. The girl complained it was uncomfortable but the doctor had said it was necessary to keep her wound clean. And, besides, the sight of her ruined eyes frightened the other girls.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The schoolmistress got up and went over to her, just as she succeeded in untying the knot.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now, Martha,” she said, deftly tying it back up again. “Remember what the doctor said.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The girl hung her head and said nothing. She hadn’t spoken much since the accident. Not since the doctor had come and Martha had made those ridiculous accusations.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you go and join the girls in their game?” the schoolmistress said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blind girl shook her head and spoke so quietly that the teacher had to strain to hear. “It’s a bad game.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nonsense. Come along now and play with the others. I’m sure they can help you if you ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took Martha’s hand and tugged her, stumbling along, to where the girls were playing in the sunshine. But when she got there she found that they weren’t making dresses for the dolls after all. They were making shrouds. And they’d covered the dolls up with them as if they were corpses. Some of the girls were even making little crosses out of twigs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you doing?” the schoolmistress said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The girls looked up at her. “We’re holding a funeral for the Frozen Charlottes, Miss Grayson.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, stop it at once,” the teacher replied. “I never heard of anything so ghoulish.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But, miss,” one of the girls said, “they like being dead. They told us.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40416f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545941099_fm001.vue
// module id = 66
// module chunks = 0